class MainMenu {
    constructor() {
        this.$elm = $('.header');

        this.$icon = this.$elm.find('.hamburger');
        this.$mainmenu = this.$elm.find('.mainMenu');

        this.activeClass = 'is-active';

        this.setEventListeners();
    }

    setEventListeners() {
        this.$icon
            .on('click', this.onMenuIconClick.bind(this));
        $(document)
            .on('click', function(event){
                var $target = $(event.target);
                if(!$target.closest(this.$mainmenu).length && this.$mainmenu.hasClass('mainMenu--isOpen')) {
                    this.close();
                }
                var $parent = $target.closest('.mainmenu-item');
                if (!$parent.hasClass('mainmenu-item--hasChildren')) {
                    var $link = $parent.find('a');
                    if ($link && $link.attr('href')) window.location.href = $link.attr('href');
                }
            }.bind(this));
    }

    toggle() {
        if (this.$icon.hasClass(this.activeClass)) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$icon.addClass(this.activeClass);
        this.$mainmenu.addClass('mainMenu--isOpen');
        this.$elm.addClass('menu-isOpen');
    }

    close() {
        this.$icon.removeClass(this.activeClass);
        this.$mainmenu.removeClass('mainMenu--isOpen');
        this.$elm.removeClass('menu-isOpen');
    }

    onMenuIconClick(event) {
        event.preventDefault();
        event.stopPropagation();

        this.toggle();
    }
}

export default MainMenu;